import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaArrowLeft } from 'react-icons/fa';
import { postData } from '../api';
import { getItemsUrl, PREV_IMG } from '../constants/endPoints';
import { convertFromBase64 } from '../constants/helper';
import { getItemData } from '../Hooks/useItemParams';
import { SERVICES, CARS } from '../constants';
import DataNotFound from './DataNotFound';
import AppLoader from './Components/AppLoader';
import ProductListItem from './Components/ProductListItem';
import ProductListServiceItem from './Components/ProductListServiceItem';
import ProductListRentCarItem from './Components/ProductListRentCarItem';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SEO from '../Components/SEO';

/**
 * Public seller profile — shows the seller's basic info and every
 * published item they have posted (cars, bikes, services, etc).
 * Reached via /seller/:id where :id is base64(added_user_id).
 */
const SellerProfile = ({ ...props }) => {
    const { id } = useParams();
    const sellerId = convertFromBase64(id);
    const [seller, setSeller] = useState(null);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(20);
    const [products, setProducts] = useState({ isLoading: false, data: [] });
    const [loadMoreTxt, setLoadMoreTxt] = useState('Carregar mais');

    const getPageData = async () => {
        try {
            setProducts((prev) => ({ ...prev, isLoading: true }));
            let reqData = getItemData();
            reqData.added_user_id = sellerId;
            let res = await postData(getItemsUrl('search', limit, 0), reqData);
            let data = res.data || [];
            setProducts({ isLoading: false, data });
            if (data.length > 0) {
                setSeller(data[0].user);
            }
        } catch (e) {
            console.log(e);
            setProducts((prev) => ({ ...prev, isLoading: false }));
        }
    };

    const loadMore = async () => {
        try {
            setLoadMoreTxt('Carregando...');
            let reqData = getItemData();
            reqData.added_user_id = sellerId;
            let nextOffset = offset + limit;
            let res = await postData(getItemsUrl('search', limit, nextOffset), reqData);
            let data = res.data || [];
            setProducts((prev) => ({ isLoading: false, data: [...prev.data, ...data] }));
            setOffset(nextOffset);
            setLoadMoreTxt(data.length < limit ? 'Sem mais anúncios' : 'Carregar mais');
        } catch (e) {
            setLoadMoreTxt('Sem mais anúncios');
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setSeller(null);
        setOffset(0);
        getPageData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <main className="seller-profile-page productList">
            <SEO
                title={seller && seller.user_name ? `Anúncios de ${seller.user_name} | InfoMotores` : undefined}
                description={seller && seller.user_name ? `Veja todos os anúncios de ${seller.user_name} na InfoMotores.` : undefined}
                image={seller && seller.user_profile_photo ? PREV_IMG + seller.user_profile_photo : undefined}
            />
            <div className="b-crumbs-wrap">
                <div className="cont b-crumbs">
                    <ul>
                        <li className="b-crumbs-back">
                            <a onClick={() => { window.history.back(); }}><FaArrowLeft /> Voltar</a>
                        </li>
                        <li><Link to="/">Motor</Link></li>
                        <li><span>Perfil do vendedor</span></li>
                    </ul>
                </div>
            </div>

            <div className="cont maincont">

                {!seller && products.isLoading && (
                    <div className="d-flex justify-content-center align-items-center mt-8" style={{ height: 200 }}>
                        <Spinner animation="grow" />
                    </div>
                )}

                {seller && (
                    <div className="seller-profile-card">
                        <img
                            className="seller-profile-photo"
                            src={PREV_IMG + seller.user_profile_photo}
                            onError={(e) => { e.target.src = './assets/images/placeholder.jpeg'; }}
                            alt={seller.user_name}
                        />
                        <div className="seller-profile-info">
                            <h3>{seller.user_name}</h3>
                            {seller.added_date_str && <p className="seller-profile-since">Membro desde {seller.added_date_str}</p>}
                            <div className="seller-profile-badges">
                                {seller.phone_verify == 1 && <span className="seller-badge"><FaPhone /> Telefone verificado</span>}
                                {seller.email_verify == 1 && <span className="seller-badge"><FaEnvelope /> Email verificado</span>}
                            </div>
                            <p className="seller-profile-count">{products.data.length} anúncio{products.data.length != 1 ? 's' : ''}</p>
                        </div>
                    </div>
                )}

                <h2 className="pt-3"><span>Anúncios deste vendedor</span></h2>

                <div className="section-list row">
                    {!products.isLoading && products.data.length < 1 && <DataNotFound hideTopBar={true} message="Este vendedor não tem anúncios ativos de momento." showAllLink={true} />}
                    {products.isLoading && products.data.length < 1 && <AppLoader />}
                    {
                        products.data && products.data.map((val, i) => {
                            let loc = {};
                            props.location.data.forEach((locData) => {
                                if (locData.id == val.item_location_id) loc = locData;
                            });
                            if (val.category_id == SERVICES) {
                                return <ProductListServiceItem val={val} i={i} loc={loc} key={'seller-item-' + i} />;
                            }
                            if (val.category_id == CARS && val.sell_type == 'Rent') {
                                return <ProductListRentCarItem val={val} i={i} loc={loc} key={'seller-item-' + i} />;
                            }
                            return <ProductListItem val={val} i={i} loc={loc} key={'seller-item-' + i} />;
                        })
                    }
                </div>

                {products.data.length >= limit && (
                    <div className="lbl-load-more">
                        <label onClick={loadMore}>{loadMoreTxt}</label>
                    </div>
                )}

            </div>
        </main>
    );
};

const mapLocationWithProps = (state) => {
    return {
        location: state.location
    };
};

export default compose(
    connect(mapLocationWithProps),
)(SellerProfile);